const supportedActions = {
  SELECT_OPTION: 'select-option',
  DESELECT_OPTION: 'deselect-option',
}

export default supportedActions
